<template>
  <div>
    <sub-content-container :title="$t('aboutMe.workExperience.pageLabel')">
      <job-position
        v-for="(position, i) in completePositions"
        :position="position"
        :key="`position-${i}`"
      />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const JobPosition = () =>
  import(/* webpackChunkName: "WorkExperiencePage" */ "@/components/AboutMe/JobPosition");

export default {
  name: "WorkExperience",
  components: {
    SubContentContainer,
    JobPosition
  },
  data() {
    return {
      positions: [
        {
          company: "KarmaCheck",
          logotype: "/img/jobsLogotype/karmacheck.png"
        },
        {
          company: "FactoryFix",
          logotype: "/img/jobsLogotype/factoryfix.png"
        },
        {
          company: "FactoryFix (subcontracted via Gold Media Tech)",
          logotype: "/img/jobsLogotype/goldmediatech.png"
        },
        {
          company: "The Digital Support",
          logotype: "/img/jobsLogotype/thedigitalsupport.png",
          backgroundColor: "black"
        },
        { company: "Tecnocen", logotype: "/img/jobsLogotype/tecnocen.jpg" },
        { company: "Upwork", logotype: "/img/jobsLogotype/upwork.png" },
        {},
        {
          company: "ABC Digital",
          logotype: "/img/jobsLogotype/abcdigital.png",
          backgroundColor: "black"
        },
        {
          company: "Edelmann Group"
        }
      ]
    };
  },
  computed: {
    completePositions() {
      return this.positions.map((data, i) => {
        const technologies = [];
        if (data.technologies && data.technologies.length) {
          technologies.push(...data.technologies);
        }
        if (
          this.$t("aboutMe.workExperience.positions")[i].technologies &&
          this.$t("aboutMe.workExperience.positions")[i].technologies.length
        ) {
          technologies.push(...this.$t("aboutMe.workExperience.positions")[i].technologies);
        }

        return {
          ...data,
          ...this.$t("aboutMe.workExperience.positions")[i],
          technologies
        };
      });
    }
  }
};
</script>
